module.exports = __webpack_public_path__ + "media/payment_icons/amex-b895984b.svg";